import { render, staticRenderFns } from "./EventDetailMore.vue?vue&type=template&id=857d29b8"
import script from "./EventDetailMore.vue?vue&type=script&lang=js"
export * from "./EventDetailMore.vue?vue&type=script&lang=js"
import style0 from "./EventDetailMore.vue?vue&type=style&index=0&id=857d29b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports